import { strMax } from '../../utils';
export const validateFolder = {
    name: [strMax(100, 'フォルダ名は100文字以内で入力してください')],
};
export default validateFolder;
